import { updatesItems } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '独家': 'bg-primary-100 text-primary-700',
  '热点': 'bg-accent-100 text-accent-800',
  '突发': 'bg-primary-500 text-background-50',
  '重磅': 'bg-accent-500 text-background-50',
  '爆料': 'bg-secondary-100 text-secondary-800',
  '内幕': 'bg-primary-100/70 text-primary-700',
  '八卦': 'bg-accent-100/70 text-accent-800',
  '深度': 'bg-secondary-500 text-background-50',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            7×24小时滚动更新，重大黑料第一时间推送
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-0.5 bg-background-200" />

            {updatesItems.map((item, idx) => (
              <div key={item.id} className="relative pb-6 md:pb-7 last:pb-0">
                <div
                  className={`absolute left-[-25px] md:left-[-29px] top-1.5 w-3 h-3 rounded-full border-2 ${
                    idx < 3
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-background-300'
                  }`}
                />

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-400 whitespace-nowrap font-medium">
                      {item.date}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.time}
                    </span>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                  <span
                    className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap flex-shrink-0 w-fit ${tagStyles[item.tag] || 'bg-secondary-100 text-secondary-700'}`}
                  >
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}